<template>
  <div class="use-platform-quote">
    <div class="form-card-box">
      <el-form-item label="国家" label-width="45px">
        <el-input :value="countryName"
                  disabled
                  class="edit-form__input"
                  style="width: 530px"
                  placeholder=""></el-input>
        <el-button type="primary"
                   v-if="!isViewStatus"
                   @click="clickSearch"
                   style="width: 138px; height: 40px;font-size: 14px"
                   class="margin-left">查询</el-button>
      </el-form-item>
      <br/>
      <use-platform-quotation-supplier-tab
        :list="tabList"
        :default-current-value.sync="tabCurrentValue"
      >
      <span slot="label" slot-scope="{itemData}">
        {{ itemData.label }}
        <template v-if="itemData.value === 'ps'">
          <template v-if="isViewStatus">
            <template v-if="viewList.length">
              ({{viewList.length}})
            </template>
          </template>
          <template v-else-if="itemData.number">
            ({{ itemData.number }})
          </template>
        </template>
      </span>
      </use-platform-quotation-supplier-tab>
      <div v-if="!isViewStatus && tabCurrentValue === 'ps'" class="margin-bottom">
        <el-button type="primary"
                   @click="showCalculation"
                   :disabled="!tableSelectItem.length"
                   plain
                   size="small">
          价格试算
          <el-tooltip
            content=""
            placement="top-start"
            effect="dark">
            <i class="el-icon-question"/>
            <div slot="content">
              1.试算前请先勾选至少一条供应商
              <br/>
              2.目前只适用美国的供应商
              <br/>
              3.只支持维护了按公里数报价的供应商参与试算
            </div>
          </el-tooltip>
        </el-button>
      </div>

      <el-table
        ref="table"
        :data="currentList"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#F9F9F9', 'font-size': '15px', 'font-weight': '500', 'color': '#141414' }"
        @selection-change="changeTableSelect"
        size="small"
        class="use-quote-table"
      >
        <el-table-column type="selection" width="55" align="center" :selectable="checkCanSelect" v-if="!isViewStatus"/>
        <el-table-column label="序号" type="index" width="96" align="center"/>
        <el-table-column label="国家" property="countryName" min-width="120" align="center"/>
        <el-table-column label="供应商名称" property="carrier" min-width="200" align="center"/>
        <el-table-column label="业务范围" property="ywfw" width="120" align="center"/>
        <el-table-column label="是否引用" property="" width="160" align="center">
          <template slot-scope="scope">
            <template v-if="isViewStatus">
              {{ isSelect(scope.row,useDeliverySupplierId) ? "是" : "否"}}
            </template>
            <el-button-group v-else>
              <el-button
                @click="switchUse(scope.row)"
                :type="isSelect(scope.row,currentUseDeliverySupplierId) ? 'primary':''"
                size="mini" >是</el-button>
              <el-button
                @click="switchUse(scope.row,undefined,false)"
                :type="isSelect(scope.row,currentUseDeliverySupplierId) ? '':'primary'"
                size="mini" >否</el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column label="操作" property="" width="120" align="center">
          <template slot-scope="scope">
            <el-link
              @click="showDetail(scope.row,scope.$index)"
              type="primary"
              :underline="false">
              查看详情
            </el-link>
          </template>
        </el-table-column>
      </el-table>

      <use-platform-quotation-supplier-details
        ref="viewDetails"
        :visible.sync="visibleDetails"
        :carrier-id="viewDetailsData.carrierId"
        :country-id="viewDetailsData.countryId"
        @closed="hideDetail"
      />
      <price-calculation
        :visible.sync="visibleCalculation"
        :country-id="countryId"
        :supplier-ids="viewCalculationSupplierIds"
        @closed="hideCalculation"
      />
    </div>
  </div>
</template>

<script>
import UsePlatformQuotationSupplierTab
  from "./supplierTypeTab";
import UsePlatformQuotationSupplierDetails
  from "@/components/QuotationManagement/components-productQuotation/usePlatformQuotation/viewSupplierDetails";
import PriceCalculation from "@/components/QuotationManagement/components-productQuotation/priceCalculation";
import qs from "qs";
import {isObject} from "my-tools-kit";
export default {
  name: "usePlatformQuotation",
  components: {PriceCalculation, UsePlatformQuotationSupplierDetails, UsePlatformQuotationSupplierTab},
  props:{
    isView:Boolean,//是否是查看状态
    countryName:[Number,String],
    countryId:[Number,String],//国家id
    carrierId:[Number,String],//供应商id
    deliveryType:String,//派送方式（KP 卡派 HP 海派）
    overseasWarehouseCityId:[Number,String],//起运城市Id
    overseasWarehouseId:[Number,String],//海外仓库Id
    useDeliverySupplierId:[Number,String],//引用报价供应商Id
  },
  data(){
    return {
      tabList:[
        {label:"干线",value:"gx",number:0,},
        {label:"清关",value:"qg",number:0,},
        {label:"拆柜",value:"cg",number:0,},
        {label:"拖柜",value:"tg",number:0,},
        {label:"派送",value:"ps",number:0,},
      ],
      tabCurrentValue:"ps",
      // 引用报价供应商Id
      currentUseDeliverySupplierId:"",
      // 列表
      loadingList:false,
      list:[],
      tableSelectItem:[],//table表格勾选内容
      /* 查看详情 */
      visibleDetails:false,
      viewDetailsData:{},
      /* 试算 */
      visibleCalculation:false,
      viewCalculationSupplierIds:[],
    }
  },
  computed:{
    isViewStatus(){
      return !!this.isView;
    },
    viewList(){
      if(!this.isViewStatus) return []
      return this.list.filter(item=>{
        return  this.isSelect(item,this.useDeliverySupplierId);
        // return `${item.carrierId||""}` === `${this.useDeliverySupplierId||""}`
      })
    },
    currentList(){
      if(this.tabCurrentValue !== "ps") return []
      if(this.isViewStatus) {
        return this.viewList;
      }else{
        return this.list;
      }
    },
  },
  watch:{
    useDeliverySupplierId:{
      immediate:true,
      handler(val){
        this.currentUseDeliverySupplierId = val;
      }
    },
  },
  methods:{
    /**
     * 重置数据
     */
    resetData(){
      this.tabList.forEach(item=>item.number=0);
      this.tabCurrentValue = "ps";

      this.currentUseDeliverySupplierId = "";

      this.list = [];
      this.clearTableSelect();

      this.visibleDetails = false;
      this.viewDetailsData = {};

      this.visibleCalculation = false;
      this.viewCalculationSupplierIds = [];
    },
    clearTableSelect(){
      this.tableSelectItem = [];
      let $table = this.$refs.table;
      if($table && typeof $table.clearSelection === "function") $table.clearSelection();
    },
    /**
     * 点击查询
     * @returns {ElMessageComponent}
     */
    clickSearch(){
      if(!this.countryId) return this.$message("缺少 国家id");
      // if(!this.carrierId) return this.$message("缺少 供应商id");
      // if(!this.deliveryType) return this.$message("缺少 派送方式");
      // if(!this.overseasWarehouseCityId) return this.$message("缺少 起运城市Id");
      // if(!this.overseasWarehouseId) return this.$message("缺少 海外仓库Id");
      this.getList();
    },
    /**
     * 获取列表
     */
    getList(){
      let url = `/api/smartQuotedPrice/getCountryAndCarrierInfo`;
      let data = {
        // "carrierId": this.carrierId,
        "countryId": this.countryId,
        // "deliveryType": this.deliveryType,
        // "overseasWarehouseCityId": this.overseasWarehouseCityId,
        // "overseasWarehouseId": this.overseasWarehouseId,
      };
      let ywfw = this.tabList.find(item=>item.value === this.tabCurrentValue);
      if(ywfw) ywfw = ywfw.label;
      else ywfw = "";

      this.clearTableSelect();

      this.loadingList = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingList = false;
          let list = res.datas || [];
          list.forEach(item=>item.ywfw = ywfw);
          this.list = list;
          let delivery = this.tabList.find(item=>item.value==="ps");
          if(delivery) delivery.number = list.length;
        })
        .catch(res=>{
          this.loadingList = false;
          this.list = [];
          let delivery = this.tabList.find(item=>item.value==="ps");
          if(delivery) delivery.number = 0;
        })
    },
    /**
     * 是否被引用
     * @param item
     * @param currentValue
     * @returns {boolean}
     */
    isSelect(item={},currentValue=""){
      if(!isObject(item)) return false;
      if(!currentValue) return false;
      return `${item.carrierId||""}` === `${currentValue||""}`;
    },
    /**
     * 切换引用状态
     * @param item
     * @param type
     * @param isUse
     * @returns {boolean}
     */
    switchUse(item,type="ps",isUse=true){
      if(!isObject(item)) return false;
      let value = "";
      if(isUse) value = item.carrierId||"";
      if(type === "ps"){
        this.currentUseDeliverySupplierId = value;
        this.$emit("update:useDeliverySupplierId",value);
        this.$emit("change",type,value);
      }
    },
    /**
     * table切换勾选
     */
    changeTableSelect(arr = []){
      this.tableSelectItem = arr.map(item=>item);
    },
    checkCanSelect(row, index){
      console.log(row,index);
      if(row.countryCode !== "US") return false;
      if(!row.isK) return false;
      return true;
    },
    /**
     * 查看详情
     * @param item
     * @param index
     */
    showDetail(item,index){
      let params = {
        countryId:item.countryId,//国家id
        carrierId:item.carrierId,//供应商id
      };
      this.viewDetailsData = params;

      this.visibleDetails = true;
      let $viewDetails = this.$refs.viewDetails;
      if($viewDetails && typeof $viewDetails.init === "function"){
        $viewDetails.init(params);
      }
    },
    hideDetail(){
      this.visibleDetails = false;
      this.viewDetailsData = {};
    },
    /**
     * 试算
     */
    showCalculation(){
      this.visibleCalculation = true;
      this.viewCalculationSupplierIds = this.tableSelectItem.map(item=>item.carrierId);
    },
    hideCalculation(){
      this.visibleCalculation = false;
      this.viewCalculationSupplierIds = [];
    },


  },
}
</script>

<style lang="scss" scoped>
.use-quote-table {
  &.el-table /deep/ {
    td{
      .cell {
        text-align: center;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #141414;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/usePlatformQuotation/index.vue